import * as React from 'react';
import ContentLoader from 'react-content-loader';
import { Row, Col } from 'react-grid-system';

export interface ItemListLoadingProps {}

const items = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

const ItemListLoading: React.FC<ItemListLoadingProps> = props => {
  return (
    <Row>
      {items.map(item => (
        <Col key={item}>
          <ContentLoader
            key={item}
            speed={2}
            width={200}
            height={280}
            viewBox="0 0 200 280"
            backgroundColor="#333"
            foregroundColor="#999"
            {...props}
          >
            <rect x="0" y="0" rx="8" ry="8" width="200" height="200" />
            <rect x="0" y="208" rx="8" ry="8" width="160" height="16" />
          </ContentLoader>
        </Col>
      ))}
    </Row>
  );
};

export default ItemListLoading;
